<template>
  <tr style="background: none">
    <td v-bind:colspan="cols"><img src="static/img/loading.gif" height="32"></td>
  </tr>
</template>

<script>
export default {
  name: 'loading-rows',
  props: ['cols']
}
</script>



// WEBPACK FOOTER //
// src/components/LoadingRows.vue